import React, { useContext, useEffect, useState } from "react";
import { HiDocumentReport } from "react-icons/hi";
import Select from "react-select";

import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import {
	Apresentation,
	ContentMain,
	DefaultButton,
	Error,
	MyTable,
	MyTableBody,
	MyTableHead,
	MyTableTR,
	Page,
	ScreenView,
	SubPageMain,
} from "../../style/default";
import { ModalContext } from "../../context/modal";
import { Skeleton } from "../../components/Skeleton/table";
import { authApi } from "../../services/api";
import MyTooltip from "../../components/Tooltip";
import { UsageModal } from "./modal-usage";
import { MyHorizontalScrollView } from "../Accounts/style";
import { customStyles } from "../../style/selectStyles";

const WhatsappUsage = () => {
	const { open, handleOpenModal } = useContext(ModalContext);
	const [isLoading, setIsLoading] = useState(false);
	const [tableData, setTableData] = useState([]);
	const [modalData, setModalData] = useState({});
	const [accounts, setAccounts] = useState([]);
	const [openExportUsageModal, setOpenExportUsageModal] = useState(false);
	const [selectedAccount, setSelectedAccount] = useState();

	const handleExportUsageModal = () => {
		setOpenExportUsageModal(true);
		handleOpenModal();
	};

	const handleAccounts = async () => {
		try {
			const { data } = await authApi.get("/account/all/select");
			const seriData = [];
			data.forEach((item) => {
				seriData.push({ label: item.name, value: item._id });
			});
			setAccounts(seriData);
		} catch (error) {}
	};

	useEffect(() => {
		handleAccounts();
	}, []);

	const populateTable = async (accountId) => {
		try {
			setIsLoading(true);
			const { data } = await authApi.get("/account/all", {
				params: {
					accountId,
				},
			});
			setTableData(data);
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		populateTable();
	}, []);

	useEffect(() => {
		if (selectedAccount) {
			populateTable(selectedAccount.value);
		}
	}, [selectedAccount]);

	return (
		<Page>
			{open && openExportUsageModal && (
				<UsageModal
					open={open}
					populateTable={populateTable}
					data={modalData}
				/>
			)}
			<Sidebar activeMenu="whatsapp-usage" />
			<ScreenView>
				<ContentMain>
					<SubPageMain>
						<Apresentation>
							<span>Controle de uso do Whatsapp</span>
							<DefaultButton
								onClick={() => {
									handleExportUsageModal();
									setModalData({ name: "Todos os clientes", _id: "all" });
								}}
							>
								Exportar todos os clientes
							</DefaultButton>
						</Apresentation>
						{isLoading ? (
							<Skeleton data={["cliente", "quantidade de númeors", "ações"]} />
						) : (
							<>
								<MyHorizontalScrollView>
									<div>
										<Select
											styles={customStyles}
											placeholder={"Filtrar por cliente"}
											options={[{ label: "Todos", value: "" }, ...accounts]}
											onChange={(e) => {
												setSelectedAccount(e);
											}}
											noOptionsMessage={() => "Nenhum dado encontrado!"}
										/>
									</div>
								</MyHorizontalScrollView>
								{tableData.length ? (
									<>
										<MyTable responsive>
											<MyTableHead>
												<MyTableTR>
													<th>cliente</th>
													<th>quantidade de números</th>
													<th>ações</th>
												</MyTableTR>
											</MyTableHead>
											<MyTableBody>
												{tableData?.map((item) => (
													<MyTableTR key={item._id}>
														<td>{item?.name ? item?.name : "-"}</td>
														<td>
															{item?.activeNumbers ? item?.activeNumbers : "-"}
														</td>
														<td
															style={{
																display: "flex",
																justifyContent: "center",
															}}
														>
															<MyTooltip
																label={`Gerar relatório Gupshup de: ${item.name}`}
															>
																<DefaultButton
																	onClick={() => {
																		handleExportUsageModal();
																		setModalData(item);
																	}}
																>
																	<HiDocumentReport size={20} />
																</DefaultButton>
															</MyTooltip>
														</td>
													</MyTableTR>
												))}
											</MyTableBody>
										</MyTable>
									</>
								) : (
									<Error>Nenhum dado encontrado</Error>
								)}
							</>
						)}
					</SubPageMain>
				</ContentMain>
				<Footer />
			</ScreenView>
		</Page>
	);
};

export { WhatsappUsage };
